import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#02060f]">
    <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16 lg:py-24">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Logo />
          <p className="mt-6 text-sm text-slate-400 max-w-sm leading-relaxed">
            Concorde Auto Acceptance provides financing for automotive retail
            installment contracts.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-xs tracking-[0.2em] text-slate-500 uppercase">Company</p>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link data-testid="footer-link-home" className="text-slate-400 hover:text-white transition-colors duration-300" to="/">Home</Link></li>
            <li><a data-testid="footer-link-payment" className="text-slate-400 hover:text-white transition-colors duration-300" href="https://my.blytzpay.com/#/merchant/7acdb786-1f15-4eca-aff5-f4b1fea02516/login">Make a Payment</a></li>
            <li><Link data-testid="footer-link-customer-care" className="text-slate-400 hover:text-white transition-colors duration-300" to="/customer-care">Customer Care</Link></li>
            <li><Link data-testid="footer-link-faq" className="text-slate-400 hover:text-white transition-colors duration-300" to="/faq">FAQ</Link></li>
            <li><Link data-testid="footer-link-contact" className="text-slate-400 hover:text-white transition-colors duration-300" to="/contact">Customer Service</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="font-mono text-xs tracking-[0.2em] text-slate-500 uppercase">Customer Service</p>
          <ul className="mt-5 space-y-3 text-sm text-slate-400">
            <li data-testid="footer-phone" className="font-mono"><a href="tel:+12142714800" className="hover:text-white transition-colors duration-300">(214) 271-4800</a></li>
            <li data-testid="footer-address">908 S. Buckner Blvd, Dallas, TX 75217</li>
            <li data-testid="footer-hours">Mon–Sat, 9:00 AM – 6:00 PM CT</li>
            <li><Link data-testid="footer-link-privacy" className="text-slate-400 hover:text-white transition-colors duration-300" to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link data-testid="footer-link-terms" className="text-slate-400 hover:text-white transition-colors duration-300" to="/terms-of-use">Terms of Use</Link></li>
            <li><Link data-testid="footer-link-sitemap" className="text-slate-400 hover:text-white transition-colors duration-300" to="/sitemap">Sitemap</Link></li>
          </ul>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4">
        <p className="text-xs text-slate-500" data-testid="footer-copyright">
          © {new Date().getFullYear()} Concorde Auto Acceptance. All rights reserved.
        </p>
        <p className="text-xs text-slate-600 font-mono" data-testid="footer-sister-company">
          Sister company of AutoCityCredit.com
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
